import * as React from 'react';
import { graphql } from 'react-apollo';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { compose } from 'recompose';
import getClientEnvironment from '../../getClientEnvironment';
import { CompositeComponent } from '../types';
import withToggleState, { ToggleStateProps } from '../withToggleState';
import { DisconnectMutation, LoggedInUserQuery } from './queries';
import { DisconnectPayload } from './types';
import withDisconnect, { DisconnectProps } from './withDisconnect';

const config = getClientEnvironment();

export interface DisconnectProps {
    disconnect: () => Promise<any>;
}

/** Provides components with a disconnect function */
export default graphql<any, DisconnectPayload, {}, DisconnectProps>(
    DisconnectMutation,
    {
        props: ({ mutate }) => ({
            disconnect: async () => {
                if (!mutate) {
                    throw new Error('No mutate function provided');
                }
                await mutate({
                    refetchQueries: [{ query: LoggedInUserQuery }]
                });

                // Redirect the user to the home page, which will also nuke the apollo cache
                window.location.href = '/';
            }
        })
    }
);

export interface ConfirmDisconnectProps {
    confirmDisconnect?: () => void;
}

/** Show a confirmation dialog to explain that disconnecting means permanently logging out */
export const withConfirmDisconnect = compose<ConfirmDisconnectProps, {}>(
    withDisconnect,
    withToggleState(),
    (InnerComponent: CompositeComponent<ConfirmDisconnectProps>) => ({
        disconnect,
        active,
        toggle,
        ...rest
    }: DisconnectProps & ToggleStateProps) => (
        <>
            <InnerComponent confirmDisconnect={toggle} {...rest} />
            <Modal isOpen={active} centered={true} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>
                    Disconnect {config.TITLE} from Strava
                </ModalHeader>
                <ModalBody className="p-3">
                    <p>
                        Disconnecting from Strava will sign you out of{' '}
                        {config.TITLE} on all your devices, and stop us from
                        accessing your Strava data.
                    </p>
                    <p>
                        All your data held on our servers will be deleted, but
                        data held by Strava will not be affected.
                    </p>
                    <p>Thank you for using {config.TITLE}</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={disconnect}>
                        Disconnect from Strava
                    </Button>{' '}
                    <Button color="secondary" onClick={toggle}>
                        No thanks!
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
);



// WEBPACK FOOTER //
// ./src/client/components/Login/withDisconnect.tsx